import styled from 'styled-components';
import { colors } from 'styles/colors';
import { Button } from 'components';

export const BigNumber = styled.div<{comingSoon?: boolean}>`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  opacity: ${({ comingSoon }) => (comingSoon ? 0.6 : 1)};
`;

export const BigNumberHeader = styled.h4<{disabledColor?: boolean}>`
  margin: 0;
  color: ${({ disabledColor }) => (disabledColor ? colors.text['disabled-300'] : colors.text['main-900'])};
  font-weight: 700;
  font-size: 32px;
  line-height: 130%;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const BigNumberCardContainer = styled.div`
  width: auto;
  height: 104px;
  display: flex;
  align-items: start;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  @media (min-width: 769px) {
    max-width: 400px;
    flex: 1 0 260px;
  }

  @media (max-width: 768px) {
    min-width: 316px;
  }
`;

export const BigNumberIcon = styled.div`
  width: 32px;
  height: 32px;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.brand.primary.lighterAlt};
`;

export const Description = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;

  h5 {
    font-weight: 600;
    font-size: 12px;
    line-height: 180%;
    margin: 0;
    color: ${colors.text['main-900']};
    white-space: nowrap;
  }

  & > .tooltip-bignumber {
    max-width: 400px;
    opacity: 1 !important;
  }
`;

export const SubDescription = styled.div<{ comingSoon?: boolean; breakLine?: boolean }>`
  max-width: ${({ breakLine }) => (breakLine ? '224px' : 'auto')};
  display: ${({ breakLine }) => (breakLine ? 'block' : 'flex')};
  gap: 2px;
  opacity: ${({ comingSoon }) => (comingSoon ? 0.6 : 1)};

  & > span {
    font-size: 12px;
    line-height: 180%;
    color: ${colors.text['soft-400']};
    white-space: ${({ breakLine }) => (breakLine ? 'normal' : 'nowrap')};
  }

  & > span:nth-child(1) {
    font-weight: 700;
  }

  & > span:nth-child(2) {
    font-weight: 400;
    padding-left: ${({ breakLine }) => (breakLine ? '2px' : '0')};
  }
`;

export const DetailsButton = styled(Button)`
  width: 92px;
  height: 25px;
  margin-top: 8px;
  white-space: nowrap;

  margin-left: auto;
`;

export const IndicatorContainer = styled.div<{color: string }>`
  width: 12px;
  height: 12px;
  margin: auto 0;
  border-radius: 9999px;
  background-color: ${({ color }) => color};
`;

export const ComingSoonBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  margin-top: 8px;
  margin-left: auto;
  border: 1px solid ${colors.brand.primary.base};
  border-radius: 4px;
  background-color: transparent;
  color: ${colors.brand.primary.base};
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  width: 92px;
  height: 25px;
  opacity: 1;
  text-transform: uppercase;
`;
